import { cn } from "@/lib/utils";

const variants = {
  primary: "bg-primary/12 text-primary-strong",
  secondary: "bg-secondary/25 text-secondary-ink",
  teal: "bg-teal/15 text-teal-ink",
  blue: "bg-blue/12 text-blue-ink",
  success: "bg-success/15 text-success-ink",
  info: "bg-info/12 text-info-ink",
  warning: "bg-warning/15 text-warning-ink",
  neutral: "bg-muted text-muted-foreground",
};

const dotColor = {
  primary: "bg-primary",
  secondary: "bg-secondary-ink",
  teal: "bg-teal",
  blue: "bg-blue",
  success: "bg-success",
  info: "bg-info",
  warning: "bg-warning",
  neutral: "bg-muted-foreground",
};

export function BloomBadge({ variant = "primary", dot = false, icon: Icon, className, children }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-bold",
        variants[variant],
        className,
      )}
    >
      {dot && <span className={cn("h-2 w-2 rounded-full", dotColor[variant])} />}
      {Icon && <Icon size={15} weight="bold" />}
      {children}
    </span>
  );
}

export default BloomBadge;
